import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import VueMeta from "vue-meta";
import { Auth } from 'aws-amplify';
import store from '../state/store';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});
const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

console.log('Set before each');
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  var authpage = routeTo.meta.authRequired;
  const loggeduser = JSON.parse(localStorage.getItem("userData"));


  console.log(routeTo);
  if(routeTo.name == 'home'){
    if(!loggeduser){
      return next("/login");
    } else {
      return next("/my-space/campaigns");
    }
  }

  var publicRoutes = ['login','register','browse-space','forgot-password','reset-password']

  if(publicRoutes.includes(routeTo.name) && loggeduser){
    return next("/");
  }

  console.log(loggeduser);
  console.log(authpage);

  if (authpage && !loggeduser) {
    return next("/login");
  } else if (authpage && (loggeduser !== null || loggeduser !== undefined)) {
    const time = Date.now()
    let timenow = Math.floor(time / 1000);

    if (loggeduser.expirationTime - timenow > 0) {
      Auth.currentAuthenticatedUser()
        .then(async (user) => {
          let currentSession = user.signInUserSession
          user.refreshSession(currentSession.refreshToken, (err, session) => {
            if (err) {
              Auth.signOut()
                .then(() => {
                  store.commit('auth/CLEAR_CURRENT_USER');
                  return next("/login");
                }).catch(err => console.log("Error refreshing tokens: " + err));
            } else {
              let userData = JSON.parse(localStorage.getItem('userData'))
              let tmp_userData = {
                ...userData,
                jwtToken: session.idToken.jwtToken
              }
              store.commit('auth/SET_CURRENT_USER', tmp_userData);
              return next();
            }
          })
        })
        .catch(err => console.log("Auth.currentAuthenticatedUser(): " + err));
    } else {
      await Auth.signOut()
        .then(() => {
          store.commit('auth/CLEAR_CURRENT_USER');
          return next("/login");
        }).catch(err => console.log("Error refreshing tokens: " + err));
    }
  } else {
    return next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...

            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
